import { reactive } from "vue"
interface urlType  {
    url:string,
    partText:string,
    path?:string,
    section?:string,
    id?:number
}
export interface downShowType {
    title?: string,
    introductory?: string,
    path_url?:string,
    urls?: urlType[],
}
export const downData = reactive<downShowType[]>([
    {},
    {
        title: '关于我们',
        path_url:'/about.html',
        introductory: '南通宇启升机电设备有限公司是一家从事工业物联网产品研发&工业自动化&视频监控综合应用的高新技术企业。',
        urls: [
            {
                url:'/images/500944321_banner.png',
                partText:'公司简介',
                path:'/about.html',
                id:1
            },
            {
                url:'/images/d0hCJhpMTK2s8IkzbfMc9Q.png',
                partText:'企业文化',
                path:'/enterprise_culture.html',
                id:1
            },
            {
                url:'/images/RvyHW4BJRwGjf68yiFn09w.png',
                partText:'资质荣誉',
                path:'/qualification_honor.html',
                id:1
            },
            {
                url:'/images/FPLm75yvS9i693JVG9DiWw.png',
                partText:'组织机构',
                section:'section4',
                id:1

            },
            {
                url:'/images/bTVAI0HgSjCBcMQwvphM0g.png',
                partText:'发展历程',
                section:'section5',
                id:1
            },
        ]
    },
    {
        title: '主营产品',
        path_url:'/products.html',
        introductory: '宇启升致力于开展高、低压成套控制柜、变频控制柜等可根据客户需求量身定做。支持5G/4G/3G/2G网络，实现数据采集、存储、控制、报警及传输等综合功能。通过终端传感设备，实时采集信息，然后通过网络接入。',
        urls: [
            {
                url:'/images/product.png',
                partText:'控制柜',
                path:'/products.html',
                id:21
            },
            {
                url:'/images/product1.png',
                partText:'行业终端设备',
                path:'/terminal.html',
                id:22
            },
            {
                url:'/images/product2.png',
                partText:'智慧管控平台',
                path:'/wisdom.html',
                id:23
            },
            {
                url:'/images/20240809104706_20240809104726A002.jpg',
                partText:'产品展示',
                path:'/Exhibition.html',
                id:24
            },
        ]
    },
    {
        title: '工程案列',
        path_url:'/performance.html',
        introductory: '宇启升执行现代化管理制度，有着多年高、低压电气成套设备的生产经验，按客户需求量身定制自动化控制解决方案。汇集多名具有丰富经验的技术工程师，具有配电和自控设计及软件编程开发的能力。',
        urls: [
            {
                url:'/images/MU3lczcnTOqggGxkLsVU3A.png',
                partText:'工程业绩',
                path:'/performance.html',
                id:31
            },
            {
                url:'/images/Rhx_1DmhRoCwmvEfVYtFdQ.png',
                partText:'应用案例',
                path:'/application_case.html',
                id:32
            },
            {
                url:'/images/RtutAprERt6KEUGE-eZyNg.png',
                partText:'工程实景图',
                path:'/realistic_picture.html',
                id:33
            },
        ]
    },
    {
        title: '合作伙伴',
        path_url:'/partner.html',
        introductory: '可靠的元器件是确保控制柜质量的重要保证。我公司长期选用ABB、西门子、施耐德、魏德米勒等具有良好声誉和质量的高端优质品牌，保证设备可靠、安全、稳定。',
        urls: [
            {
                url:'/images/dCC022k_SE-ZrlFmT37jdg.png',
                partText:'合作供应商·授权书',
                path:"/partner.html",
                id:4
            }
        ]
    },
    {
        title: '联系我们',
        path_url:'/contact.html',
        introductory: '如果您对我们公司有任何建议或对我们的产品有需求的话，请您按照以下提供的联系方式与我们联系，非常感谢您一直以来对于我们的支持和关注!',
        urls: [
            {
                url:'/images/FybacxnBSjuu-uIIe3Lmvg.png',
                partText:'联系方式',
                section:'section1',
                path:'/contact.html',
                id:5
            },
            {
                url:'/images/hKT5L0SSSjSAm8KQoE64sw.png',
                partText:'加入我们',
                section:'section2',
                path:'/join_us.html',
                id:6
            },
        ]
    }
])